"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseRangeValue = exports.getRangeValue = exports["default"] = void 0;
var _CatchFromControl = require("../CatchFromControl");
var _styles = require("@mui/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _reactDebounceInput = require("react-debounce-input");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["inputRef", "tabIndex", "className", "defaultValue", "id", "name", "placeholder", "variant", "required", "value", "onKeyDown", "onKeyUp", "onBlur", "onChange", "onFocus", "minInputPlaceholder", "maxInputPlaceholder", "debounceTimeout"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      // maxWidth: '40%',
      display: "flex",
      alignItems: "center",
      position: "relative"
    },
    input: {
      width: "50%",
      textAlign: "center",
      appearance: "none",
      "&::-webkit-inner-spin-button": {
        appearance: "none",
        margin: 0
      }
    },
    separator: {
      width: "12px",
      textAlign: "center",
      margin: "0 -6px",
      pointerEvents: "none"
    }
  };
}, {
  name: "GgNumberRangeInput"
});
var getRangeValue = exports.getRangeValue = function getRangeValue(value) {
  var min = value === null || value === void 0 ? void 0 : value.min;
  var max = value === null || value === void 0 ? void 0 : value.max;
  return min !== undefined || max !== undefined ? "".concat(min !== null && min !== void 0 ? min : "", "_").concat(max !== null && max !== void 0 ? max : "") : "";
};
var numberOrNothing = function numberOrNothing(value) {
  var numVal = parseInt(value);
  return isNaN(numVal) ? undefined : numVal;
};
var parseRangeValue = exports.parseRangeValue = function parseRangeValue(strValue) {
  var _strValue$split = strValue.split("_"),
    _strValue$split2 = _slicedToArray(_strValue$split, 2),
    minStr = _strValue$split2[0],
    maxStr = _strValue$split2[1];
  return {
    min: numberOrNothing(minStr),
    max: numberOrNothing(maxStr)
  };
};
var RangeInput = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _rangeValue$min, _rangeValue$max;
  var inputRef = _ref.inputRef,
    tabIndexProp = _ref.tabIndex,
    className = _ref.className,
    defaultValue = _ref.defaultValue,
    id = _ref.id,
    name = _ref.name,
    omittedPlaceholder = _ref.placeholder,
    variant = _ref.variant,
    required = _ref.required,
    value = _ref.value,
    onKeyDown = _ref.onKeyDown,
    onKeyUp = _ref.onKeyUp,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    _ref$minInputPlacehol = _ref.minInputPlaceholder,
    minInputPlaceholder = _ref$minInputPlacehol === void 0 ? "min" : _ref$minInputPlacehol,
    _ref$maxInputPlacehol = _ref.maxInputPlaceholder,
    maxInputPlaceholder = _ref$maxInputPlacehol === void 0 ? "max" : _ref$maxInputPlacehol,
    _ref$debounceTimeout = _ref.debounceTimeout,
    debounceTimeout = _ref$debounceTimeout === void 0 ? 300 : _ref$debounceTimeout,
    props = _objectWithoutProperties(_ref, _excluded);
  var disabled = props.disabled;
  var rangeRef = (0, _react.useRef)(null);
  var minInputRef = (0, _react.useRef)(null);
  var maxInputRef = (0, _react.useRef)(null);
  var rangeValue = (0, _react.useMemo)(function () {
    return rangeRef.current = parseRangeValue(value);
  }, [value]);
  var classes = useStyles();
  var formControl = (0, _CatchFromControl.useFormControl)();
  var tabIndex;
  if (typeof tabIndexProp !== "undefined") {
    tabIndex = tabIndexProp;
  } else {
    tabIndex = disabled ? null : 0;
  }
  var executeChange = (0, _react.useCallback)(function (key, v) {
    var newRange = _objectSpread(_objectSpread({}, rangeRef.current), {}, _defineProperty({}, key, v));
    onChange({
      persist: function persist() {},
      target: {
        value: getRangeValue(newRange),
        name: name
      }
    });
  }, [onChange]);
  var handleMinChange = (0, _react.useCallback)(function (e) {
    executeChange("min", e.target.value);
  }, [executeChange]);
  var handleMaxChange = (0, _react.useCallback)(function (e) {
    executeChange("max", e.target.value);
  }, [executeChange]);
  (0, _react.useImperativeHandle)(inputRef, function () {
    return {
      focus: function focus() {
        minInputRef.current.focus();
      },
      value: getRangeValue(rangeValue)
    };
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: ref,
    tabIndex: tabIndex,
    onFocus: onFocus,
    onBlur: onBlur,
    className: (0, _clsx["default"])(classes.root),
    onKeyUp: onKeyUp,
    onKeyDown: onKeyDown,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactDebounceInput.DebounceInput, _objectSpread(_objectSpread({}, props), {}, {
      inputRef: minInputRef,
      className: (0, _clsx["default"])(classes.input, className),
      value: (_rangeValue$min = rangeValue === null || rangeValue === void 0 ? void 0 : rangeValue.min) !== null && _rangeValue$min !== void 0 ? _rangeValue$min : "",
      onChange: handleMinChange,
      placeholder: minInputPlaceholder,
      debounceTimeout: debounceTimeout,
      "data-cy-role": "rangeMin"
    })), formControl !== null && formControl !== void 0 && formControl.filled || formControl !== null && formControl !== void 0 && formControl.focused ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: classes.separator,
      children: "\u2013"
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactDebounceInput.DebounceInput, _objectSpread(_objectSpread({}, props), {}, {
      inputRef: maxInputRef,
      className: (0, _clsx["default"])(classes.input, className),
      value: (_rangeValue$max = rangeValue === null || rangeValue === void 0 ? void 0 : rangeValue.max) !== null && _rangeValue$max !== void 0 ? _rangeValue$max : "",
      onChange: handleMaxChange,
      placeholder: maxInputPlaceholder,
      debounceTimeout: debounceTimeout,
      "data-cy-role": "rangeMax"
    }))]
  });
});
var _default = exports["default"] = RangeInput;